// extracted by mini-css-extract-plugin
module.exports = {"container":"coupon_container__3pbCY"};